import type { BrandingDb } from '@domain/schemas/branding.schema';
import dayjs from 'dayjs';

export const getAuthorship = (branding: Partial<BrandingDb>) =>
  `Last updated ${dayjs(branding.updated_at ?? branding.created_at).fromNow()}${
    !!branding.last_updated_by && ` by ${branding.last_updated_by.name}`
  }`;
